<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>{{ $t('auto.labels.complectation') }}</h3>
        <v-label>{{ $t('auto.label.complectationHint') }}</v-label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="5" class="complectation-column">
        <v-row v-for="item in equipmentList.firstSection" :key="item[0]">
          <v-col cols="8" class="mt-1">
            {{ item[1] }}
          </v-col>
          <v-col cols="4">
            <v-select
              v-if="isCountSelect(item[0])"
              v-model="credentials[item[0]]"
              item-text="text"
              item-value="value"
              class="mt-0 pt-0"
              :items="countItems"
            />
            <v-select
              v-else
              :items="propertyItems"
              v-model="credentials[item[0]]"
              item-text="title"
              item-value="id"
              class="mt-0 pt-0"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-show="$vuetify.breakpoint.mdAndUp"
        class="text-center complectation-column"
      >
        <v-divider vertical></v-divider>
      </v-col>
      <v-col cols="12" sm="12" md="5" class="complectation-column">
        <v-row v-for="item in equipmentList.secondSection" :key="item[0]">
          <v-col cols="8" class="mt-1">
            {{ item[1] }}
          </v-col>
          <v-col cols="4">
            <v-select
              v-if="isCountSelect(item[0])"
              v-model="credentials[item[0]]"
              item-text="text"
              item-value="value"
              class="mt-0 pt-0"
              :items="countItems"
            />
            <v-select
              v-else
              :items="propertyItems"
              v-model="credentials[item[0]]"
              item-text="title"
              item-value="id"
              class="mt-0 pt-0"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CheckList',
  props: {
    checkList: Object,
    checkListCount: Object,
  },
  data() {
    return {
      credentials: {},

      countItems: [
        { text: this.$t('common.fields.noItem'), value: '0' },
        { text: 1, value: '1' },
        { text: 2, value: '2' },
        { text: 3, value: '3' },
        { text: 4, value: '4' },
        { text: 5, value: '5' },
      ],
    };
  },
  computed: {
    propertyItems() {
      return [
        {
          id: '0',
          title: this.$t('common.fields.noItem'),
        },
        {
          id: '1',
          title: this.$t('common.fields.yesItem'),
        },
      ];
    },
    equipmentList() {
      const { equipment } = this.$store.state.auto.autosState;
      const array = Object.entries(equipment || {});
      const middleIdx = Math.ceil(array.length / 2);

      return {
        firstSection: array.slice(0, middleIdx),
        secondSection: array.slice(middleIdx),
      };
    },
    equipmentCount() {
      return this.$store.state.auto.autosState.equipment_count;
    },
  },
  methods: {
    isCountSelect(key) {
      return this.equipmentCount.includes(key);
    },
    getComponentData() {
      this.$emit('update:checkList', this.credentials);
    },
    writeDataToFields(data) {
      this.credentials = data;
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 300;
}
.hint {
  color: #bababa;
}
.complectation-column {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
